import { createSlice } from "@reduxjs/toolkit";

function getStoredMode() {
  try {
    return localStorage.getItem("colorMode") || "system";
  } catch {
    return "system";
  }
}

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    color: "#2574d1",
    colorMode: getStoredMode(), // "system" | "light" | "dark"
  },
  reducers: {
    setColor: (state, action) => {
      const { color } = action.payload;
      state.color = color;
      localStorage.setItem("color", JSON.stringify(color));
    },
    setColorMode: (state, action) => {
      state.colorMode = action.payload;
      try {
        localStorage.setItem("colorMode", action.payload);
      } catch {}
    },
  },
});

export const { setColor, setColorMode } = themeSlice.actions;

export default themeSlice.reducer;
export const selectCurrentColor = (state) => state?.theme?.color;
export const selectColorMode = (state) => state?.theme?.colorMode;
